import React from "react";
import WebSocket from "src/components/webSocket";

import { useDispatch } from "react-redux";
import { createGDocEditorReference } from "src/redux/actions/gdocIntegration";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import _ from "lodash";
import styles from "./gdocs.module.scss";

const LoadingImage = '/images/loading_plane.gif';

const GDocEditor: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const assetId = params.assetId;

  const editor = useSelector((state: any) =>
    _.get(state, "gDocIntegration.item", null),
  );

  React.useEffect(() => {
    if(assetId) {
      dispatch(createGDocEditorReference({ assetId: assetId }));
    }
  }, []);

  React.useEffect(() => {
    if (editor !== null) {
      window.location = editor.url;
    }
  }, [editor]);

  return (
    <WebSocket>
      <div className={styles.content}>
        <img src={LoadingImage} className={styles.icon} />
        <div className={styles.message}>Preparing editor for asset...</div>
      </div>
    </WebSocket>
  );
};

export default GDocEditor;
